<template>
  <div class="calico-contained-icon-page">
    <div class="calico-contained-icon-container">
      <div class="calico-contained-icon-row">
        <i class="bi bi-shop contained-icon-xsmall" />
        <i class="bi bi-shop contained-icon-xsmall-outlined" />
      </div>
      <div class="calico-contained-icon-row">
        <i class="bi bi-shop contained-icon-small" />
        <i class="bi bi-shop contained-icon-small-outlined" />
      </div>
      <div class="calico-contained-icon-row">
        <i class="bi bi-shop contained-icon-medium" />
        <i class="bi bi-shop contained-icon-medium-outlined" />
      </div>
      <div class="calico-contained-icon-row">
        <i class="bi bi-shop contained-icon-large" />
        <i class="bi bi-shop contained-icon-large-outlined" />
      </div>
    </div>
  </div>
</template>

<script lang="js">
export default {
  name: 'CalicoContainedIconPage',
  data () {
    return {
      text1: '',
      text2: '',
      text3: '',
      text4: '',
      text5: '',
      text6: '',
      text7: '',
      text8: '',
      text9: '',
      text10: '',
      text11: '',
      text12: ''
    }
  },
  watch: {
    text1 (value) {
      console.log(value)
    },
    text2 (value) {
      console.log(value)
    },
    text3 (value) {
      console.log(value)
    },
    text4 (value) {
      console.log(value)
    },
    text5 (value) {
      console.log(value)
    },
    text6 (value) {
      console.log(value)
    },
    text7 (value) {
      console.log(value)
    },
    text8 (value) {
      console.log(value)
    },
    text9 (value) {
      console.log(value)
    },
    text10 (value) {
      console.log(value)
    },
    text11 (value) {
      console.log(value)
    },
    text12 (value) {
      console.log(value)
    }
  }
}
</script>
<style lang="scss">
.calico-contained-icon-page {
  display: flex;
  justify-content: center;
  align-items: center;
  .calico-contained-icon-container {
    @include stack-space($space-large);
    @include inset-space($space-large);
    width: 100%;
    .calico-contained-icon-row {
      @include inline-space($space-large);
      @include inset-space($space-large);
    }
  }
}
</style>
